import type { FC } from 'react';

import type { FilesKeyframeSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/files';
import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

import Image from '../../ui/image/image';
import { parseObjectIconInfo } from '../../utils/parse_object_icon_info';
import { ObjectIcon } from '../object_icon/object_icon';

import styles from './title_navigation_preview.module.css';

type Props = {
  searchItem: SearchItemEntity | undefined;
};

const closedKeyframePredicate = (
  keyframe: FilesKeyframeSchemaWithIdNullable,
): boolean => keyframe.type === 'KEYFRAME' && keyframe.status === 'CLOSED';

const TitleNavigationPreview: FC<Props> = ({ searchItem }) => {
  if (!searchItem) {
    return null;
  }
  const keyframe = searchItem.keyframes?.find(closedKeyframePredicate);
  const keyframeUrl = keyframe?.url;
  return (
    <div className={styles.tooltip_content}>
      <div className={styles.preview_title}>{searchItem.title}</div>
      {keyframeUrl ? (
        <Image src={keyframeUrl} alt="Previous asset preview" />
      ) : (
        <div className={styles.empty_thumbnail}>
          <ObjectIcon info={parseObjectIconInfo(searchItem)} size={64} />
        </div>
      )}
    </div>
  );
};

export default TitleNavigationPreview;
